import { AUTH_URLS, CLIENT_ID, APP_URLS, SCOPE } from '@/constants';
import { UserManager } from 'oidc-client-ts';

const authUrl = APP_URLS.PROD.includes(window.location.origin) ? AUTH_URLS.PROD : AUTH_URLS.DEV;

const config = {
  authority: authUrl,
  client_id: CLIENT_ID,
  redirect_uri: `${window.location.origin}/callback`,
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-renew-callback`,
  response_type: 'code',
  scope: SCOPE,
};

export const userManager = new UserManager(config);
